"use client";

import React from "react";
import { ArrowRight, Sparkles } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSashaLandonExperience() {
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="229803" id="the-birkalla-business-network" className="bg-background text-foreground relative overflow-hidden py-20 lg:py-32">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-3xl h-full bg-primary/5 blur-[120px] pointer-events-none rounded-full" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative aspect-[4/5] lg:aspect-[3/4] w-full max-w-md mx-auto lg:max-w-none overflow-hidden rounded-none shadow-3xl transition-all duration-1000 ease-out ${isImageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            {}
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/birkalla_clubroom_networking_event.png" alt="WT Birkalla Business Networking" className="absolute inset-0 w-full h-full object-cover grayscale contrast-150 brightness-75" />
            {}
            <div className="absolute inset-0 border border-primary/20 rounded-none pointer-events-none mix-blend-overlay" />
            <div className="absolute inset-0 bg-gradient-to-t from-background via-transparent to-transparent" />
          </div>

          {}
          <div ref={contentRef} className={`flex flex-col justify-center transition-all duration-1000 delay-200 ease-out ${isContentVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
            <div className="flex items-center gap-2 mb-6">
              <Sparkles className="size-5 text-primary" />
              <span className="text-primary font-mono tracking-widest uppercase text-sm font-semibold">
                50+ Local Partners
              </span>
            </div>

            <h2 className="text-4xl md:text-5xl lg:text-6xl font-default font-extrabold mb-8 leading-tight text-foreground uppercase tracking-tighter">
              The Birkalla <br className="hidden lg:block" />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary to-primary/60">
                Business Network
              </span>
            </h2>

            <div className="space-y-6 text-muted-foreground text-lg font-default leading-relaxed mb-10">
              <p>
                Join an elite circle of local enterprises and corporate leaders dedicated to the growth of WT Birkalla. Our network bridges the gap between professional excellence and community football, creating a powerful ecosystem for South Australian business.
              </p>
              <p>
                From exclusive match-day hospitality to high-impact B2B introductions, the Birkalla Business Network is designed to elevate your brand's visibility while supporting the next generation of football talent.
              </p>
            </div>

            <div>
              <Link to="/BirksBusinessNetworkPage">
                <Button variant="outline" size="lg" className="relative overflow-hidden bg-transparent border-primary text-primary hover:bg-primary hover:text-primary-foreground transition-colors duration-500 group h-14 px-8 rounded-none">
                  {}
                  <span className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-primary/20 to-transparent group-hover:translate-x-full transition-transform duration-1000 ease-in-out" />
                  
                  <span className="relative flex items-center gap-3 font-default font-bold tracking-wide text-base uppercase">
                    Join the Network
                    <ArrowRight className="size-5 transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </Button>
              </Link>
            </div>
          </div>

        </div>
      </div>
    </section>;
}